import { ROUTES } from "../../../constant";

interface BottomNavVisibilityParams {
  pathname: string;
  isMobile: boolean;
  isBottomDrawerOpen: boolean;
  isBookingSearchForm: boolean;
}

export function shouldShowBottomNav({
  pathname,
  isMobile,
  isBottomDrawerOpen,
  isBookingSearchForm,
}: BottomNavVisibilityParams): boolean {
  if (!isMobile) return false;
  if (isBottomDrawerOpen) return false;
  if (pathname.startsWith(ROUTES.onBoarding)) return false;
  if (pathname.startsWith(ROUTES.BookingLoader)) return false;
  if (pathname.startsWith("/payment")) return false;
  if (pathname.startsWith(ROUTES.BookingInProgress)) return isBookingSearchForm;
  return true;
}
